{
    "UploadfilesFilename": "Bestandsdetails:",
    "UploadfilesFilesize": "Bestandsdetails:",
    "UploadfilesEmailserroredsendingseebelow": "Klik voor meer informatie",
    "UploadfilesSuccesswitherrorparagraph": "Hoera! We hebben uw directory-items met succes geconfigureerd.",
    "Resulttableheaderusername": "Gebruikersnaam:",
    "Resulttableheaderemail": "1) Bekijk de bijgevoegde e-mailbestanden.",
    "Resulttableheaderrptaccess": "Rapportagetoegang",
    "Resulttableheaderisadmin": "Beheerder?",
    "Resulttableheaderisocagent": "Is OC-agent?",
    "Resulttableheaderenhancemobileapp": "Verbeterde mobiele app?",
    "LanguageBulkInsertUsers_UploadfilesHeader1": "Gebruikers in bulk uploaden",
    "LanguageBulkInsertUsers_UploadfilesSubheader1": "Importeer bestand.",
    "LanguageBulkInsertUsers_UploadfilesButton1": "Begin",
    "LanguageBulkInsertUsers_UploadfilesSubheader2": "Verwerken.",
    "LanguageBulkInsertUsers_UploadfilesButton2": "Rug",
    "LanguageBulkInsertUsers_UploadfilesButton3": "Bevestigen",
    "LanguageBulkInsertUsers_UploadfilesSubheader3": "Importeren.",
    "LanguageBulkInsertUsers_UploadfilesSubheader4": "Oeps.",
    "LanguageBulkInsertUsers_UploadfilesSubheader5": "Bevestiging.",
    "LanguageBulkInsertUsers_UploadfilesSubheader6": "Succes.",
    "LanguageBulkInsertUsers_UploadfilesButton4": "Gedaan",
    "LanguageBulkInsertUsers_UploadfilesSuccessparagraph1": "Hoera! We hebben uw directory-items met succes geconfigureerd.",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart1": "Begin met het downloaden en invullen van de",
    "LanguageBulkInsertUsers_UploadfilesStarttextbutton": "CSV-sjabloon",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart2": "mits.",
    "LanguageBulkInsertUsers_UploadfilesConfirmationtext": "Bevestig dat alles correct is getypt en ga dan verder met het importeren van het voltooide bestand hier (Eventuele fouten met het bestand worden opgemerkt tijdens de configuratie):",
    "LanguageBulkInsertUsers_UploadfilesChoosefile": "Kies bestand",
    "LanguageBulkInsertUsers_UploadfilesDraganddrop": "of hier slepen en neerzetten.",
    "LanguageBulkInsertUsers_UploadfilesDrophere": "Zet je bestanden hier neer...",
    "LanguageBulkInsertUsers_UploadfilesFiledetails": "Bestandsdetails:",
    "LanguageBulkInsertUsers_PromptdefaultcloseMessage": "Weet u zeker dat u het venster wilt sluiten en de voortgang wilt verliezen?",
    "LanguageBulkInsertUsers_PromptdefaultcloseConfirm": "Ja",
    "LanguageBulkInsertUsers_PromptdefaultcloseCancel": "Annuleren",
    "LanguageBulkInsertUsers_ValidationError": "Fout: we kunnen het verzoek voor bulkregistratie niet verwerken. Zie hieronder voor meer informatie.",
    "LanguageBulkInsertUsers_SuccessTitle": "Controleer uw wijzigingen en bevestig.",
    "LanguageBulkInsertUsers_InvalidfileformatError": "Fout: Ongeldige bestandsindeling, gebruik onze CSV-sjabloon.",
    "LanguageBulkInsertUsers_MaxfilesizeError": "Fout: maximale bestandsgrootte overschreden. Maximaal 10 MB toegestaan.",
    "NAME": "LanguageBulkInsertUsers"
}